import React from 'react';

const LegalText = () => {
    return(
        <>
        <div className='pt-6 text-sm'>
            <h5>Electronic W-2 and 1095-C Disclosure Information</h5>
    
            <div>We are now providing you with the option of receiving your Form W-2 and Form 1095-C in a more efficient manner as well as allowing you the opportunity to receive these tax statements sooner. To do this, you must opt-in by selecting “I Consent” after which you will be allowed to View & Print your electronic Form W-2 and Form 1095-C.</div>
            <br/>
           <div>If you elect to “Decline”, your Form W-2 and Form 1095-C will be mailed to you via the United States Postal Service no later than January 31 of the current calendar year and arrive within the general mailing time associated with 1st class mail. </div>
            
            <br/>
            <strong>Consent:</strong>
            <div>To receive your Form W-2 and Form 1095-C through this portal you must consent. To consent, select "I Consent" at the bottom of this form after reading the entire disclosure form. If you consent, then you will not receive a paper copy via the United States Postal Service. You will have agreed to receive and print your Form W-2 and Form 1095-C electronically via the portal provided by the company. </div>
            
            <br/>
            <strong>Length of Availability Online:</strong>
            <div>If you consent to electronic access, your Form W-2 and Form 1095-C will be available for you over the next 7 years unless you change your designation from Consent to Decline or you are no longer employed with the company. </div>
            
            <br/>
            <strong>Withdrawing Consent:</strong>
            <div>To withdraw your consent, simply log in and go to the Disclosure page and click “I Decline”. Your new status will be recorded with the date and time showing you had originally consented and then changed your decision. <em>Withdrawn consent is effective immediately.</em> Your Form W-2 and Form 1095-C will not be made available to you after the date/time you have withdrawn.</div>
            
            <br/>
            <strong>Corrections:</strong>
            <div>In the event you feel your Form W-2 or Form 1095-C is incorrect you must contact your Payroll Department immediately for modification and redistribution of a new tax statement.</div>
            
            <br/>
            <strong>System Requirements for Viewing:</strong>
            <div>To view the electronic Form W-2 and Form 1095-C, you can log in from your mobile or desktop device using your OKTA credentials.</div>
            
            <br/>
            <strong>System Requirements for Printing:</strong>
            <div>To print your electronic Form W-2 and Form 1095-C, you must have a PDF viewer installed on your device and your device needs to be connected to a printer that can print a PDF document.</div>
        </div>
        </>
    )
}

export default LegalText;